import React from 'react';
import WorkforceResourceOptimizationPage from './WorkforceResourceOptimizationPage';

const ResourceOptimizationResourcesPage = () => {
  return <WorkforceResourceOptimizationPage initialTab="resources" showTopTabs={false} />;
};

export default ResourceOptimizationResourcesPage;

